import React from "react";
import "./miniApp.css";

const MiniBlogTitle = () => {
  return (
    <div id="mini-title">
      <h3>Title: Why React is Better Than Angular</h3>
    </div>
  );
};

export default MiniBlogTitle;

export const MiniBlogTitleCode = `
import React from "react";
import "./miniApp.css";

const MiniBlogTitle = () => {
  return (
    <div id="mini-title">
      <h3>Title: Why React is Better Than Angular</h3>
    </div>
  );
};

export default MiniBlogTitle;
`.trim();
